import { _ } from "libs";
import React from "react";
import Progressbar from "../../leaderboards/progressbar";
import RewardItemMedium from "../reward/medium";
import cx from "classnames";

const ChallengeItemMedium = ({
	id,
	title,
	description,
	complete,
	type,
	goal,
	progress,
	reward,
	locked,
	className,
	rankable,
	rank,
	onChallengeSelected,
}: {
	id: string;
	title: string;
	description: string;
	complete: boolean;
	type: string;
	goal: number;
	progress: number;
	reward?: any;
	locked?: boolean;
	className?: string;
	rankable?: boolean;
	rank?: number;
	onChallengeSelected?: (challengeId: string, title: string) => void;
}) => {
	return (
		<div className={cx("item", "challenge", "medium", className, { complete: complete })}>
			<div className="itemBody">
				<div className="title">{title}</div>
				<div className="meta">
					<div className="label">{description}</div>
					{rankable && rank ? (
						<div className="progress">{progress}</div>
					) : (
						type === "progress" &&
						!locked && (
							<div className="progress">
								{progress}/{goal}
							</div>
						)
					)}
				</div>
			</div>
			{rankable && rank && onChallengeSelected ? (
				<span
					className="link mt-1"
					onClick={() => {
						onChallengeSelected(id, title);
					}}
				>
					{_("championship.challenge.ranking", null, { rank })}
				</span>
			) : (
				type === "progress" && !locked && <Progressbar current={progress} max={goal} />
			)}
			{reward && reward.rewardUrl && (
				<a
					href={reward.rewardUrl}
					target="_blank"
					className="challengeRewardLink mt-3"
					rel="noopener noreferrer"
				>
					<RewardItemMedium title={reward.rewardText} imageUrl={reward.iconUrl} />
				</a>
			)}
			{reward && !reward.rewardUrl && <RewardItemMedium title={reward.rewardText} imageUrl={reward.iconUrl} />}
			{locked && <div className="msg locked small w-full mt-3">{_("championship.challenge.locked")}</div>}
		</div>
	);
};

export default ChallengeItemMedium;
